import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/common";
import { COUNTRIES, CURRENCIES } from "@/lib/constants";

export const emptyClinic = {
  name: "", country: "Kenya", currency: "KES", city: "", address: "", phone: "", email: "",
  modules: { procedures: true, dental: false, insurance: false, inpatient: false },
};

const MODULES = [
  ["procedures", "Procedures", "Minor procedures & theatre billing"],
  ["dental", "Dental unit", "Dental consultations and treatments"],
  ["insurance", "Insurance", "Insurance cover & claims on invoices"],
];

export function ClinicForm({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setCountry = (name) => onChange({ ...value, country: name, currency: COUNTRIES.find((c) => c.name === name)?.currency || value.currency });
  const setMod = (k, v) => onChange({ ...value, modules: { ...value.modules, [k]: v } });
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Field label="Clinic name" className="sm:col-span-2">
        <Input value={value.name} onChange={(e) => set("name", e.target.value)} data-testid="clinic-form-name-input" />
      </Field>
      <Field label="Country">
        <Select value={value.country} onValueChange={setCountry}>
          <SelectTrigger data-testid="clinic-form-country-select"><SelectValue /></SelectTrigger>
          <SelectContent>{COUNTRIES.map((c) => <SelectItem key={c.name} value={c.name}>{c.name}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
      <Field label="Currency">
        <Select value={value.currency} onValueChange={(v) => set("currency", v)}>
          <SelectTrigger data-testid="clinic-form-currency-select"><SelectValue /></SelectTrigger>
          <SelectContent>{CURRENCIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
      <Field label="City / Town"><Input value={value.city} onChange={(e) => set("city", e.target.value)} data-testid="clinic-form-city-input" /></Field>
      <Field label="Phone"><Input value={value.phone} onChange={(e) => set("phone", e.target.value)} data-testid="clinic-form-phone-input" /></Field>
      <Field label="Address"><Input value={value.address} onChange={(e) => set("address", e.target.value)} data-testid="clinic-form-address-input" /></Field>
      <Field label="Email"><Input value={value.email} onChange={(e) => set("email", e.target.value)} data-testid="clinic-form-email-input" /></Field>
      <div className="sm:col-span-2 rounded-xl border border-slate-200 divide-y">
        {MODULES.map(([k, l, d]) => (
          <label key={k} className="flex items-center justify-between gap-3 p-3 cursor-pointer">
            <span><span className="block text-sm font-semibold text-slate-800">{l}</span><span className="text-xs text-slate-500">{d}</span></span>
            <Switch checked={!!value.modules[k]} onCheckedChange={(v) => setMod(k, v)} data-testid={`clinic-form-module-${k}`} />
          </label>
        ))}
        <div className="flex items-center justify-between gap-3 p-3 bg-slate-50">
          <span><span className="block text-sm font-semibold text-slate-800">Inpatient module</span><span className="text-xs text-slate-500">Wards, beds & admissions — coming soon</span></span>
          <Switch checked={false} disabled data-testid="inpatient-module-toggle" />
        </div>
      </div>
    </div>
  );
}
